import fetch from 'isomorphic-fetch'
import ToastrAction from 'toastr/actions/ToastrAction'
import i18n from 'simple-react-i18n'
import {
    checkAuth,
    checkError,
    genericPromise2,
    getAuthorization,
    getJson,
} from '../../../../utils/ActionUtils'
import ApplicationConf from '../../../../conf/ApplicationConf'
import LogAction from '../../../../log/actions/LogAction'

const RECEIVE_FILE = 'RECEIVE_FILE'

const ReferencialFileAction = {

    promiseReferencialFile: (path) => fetch(ApplicationConf.referencial.referencialFilesAll(), {
        method: 'POST',
        headers: getAuthorization(),
        body: JSON.stringify({ path }),
    })
        .then(checkAuth)
        .then(getJson)
        .then(checkError),

    fetchReferencialFiles: (path) => dispatch => {
        return ReferencialFileAction.promiseReferencialFile(path)
            .then((json = []) => {
                dispatch(ReferencialFileAction.receiveReferencialFile(json))
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    receiveReferencialFile: file => ({ type: RECEIVE_FILE, file }),

    fetchReferencialFile: (code, path) => dispatch => fetch(ApplicationConf.referencial.referencialFile(), {
        method: 'POST',
        headers: getAuthorization(),
        body: JSON.stringify({ code, path }),
    })
        .then(checkAuth)
        .then(getJson)
        .then(checkError)
        .then((json = {}) => {
            dispatch(ReferencialFileAction.receiveReferencialFile(json))
            return json
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError))
        }),

    updateFile(file) {
        return dispatch => {
            return fetch(ApplicationConf.referencial.referencialFiles(), {
                method: 'PUT',
                headers: getAuthorization(),
                body: JSON.stringify(file),
            })
                .then(checkAuth)
                .then(getJson)
                .then(checkError)
                .then(json => {
                    if (json.update >= 1) {
                        dispatch(ToastrAction.success(i18n.fileSuccessUpdated))
                        return true
                    }
                    throw new Error()
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                    dispatch(ToastrAction.error(i18n.updateError))
                    return false
                })
        }
    },

    deleteFile: (code, name, path) => dispatch =>
        genericPromise2(
            ApplicationConf.referencial.deleteReferencialFile(),
            {
                method: 'POST',
                headers: getAuthorization(),
                body: { code, name, path },
            },
        )
            .then(res => {
                if (res.value > 0) {
                    dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                }
                return res
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.delete} : ${err}`))
            }),
}

export default ReferencialFileAction